import React from "react";
import Cookies from 'universal-cookie';
import translateString from "../../utils/Locales";

let t = translateString;
const cookies = new Cookies();

export default class ConsegnaTest extends React.Component {
    constructor(props) {
        super(props);
        this.dbPath = cookies.get('db_path', { path: '/' });    
        this.state = { };
    }

    render() {

        return(
            <div className="backview" style={{ backgroundColor: '#3E3E3E4D' }}>
                <div className="over-view">
                    <img src={ require('../../images/validating.png') } style={{ width: '40%', height: 'auto' }} alt="Validazione" />
                    <section style={{ width: '60%', marginLeft: '10%' }}>
                        
                        <h1>{ this.props.result ? t('test_terminato') : t('consegna_test')}</h1>
                        <p>{t('info_end_test')}</p>
                        <div style={{ marginTop: 20, width: 200 }}>
                            { this.props.result && (
                                <button style={{ marginTop: 30, backgroundColor: '#1877F2', color: 'white', padding: 10, border: 0, width: '100%', borderRadius: '5px', cursor:'pointer' }} onClick={() => window.location.href =  '/' + this.dbPath + '/#/app/editCorso'} >{t('torna_indietro')}</button>
                            )}
                        </div>
                    </section>  
                </div>
            </div>
        );
    }
}